
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"28","height":"28","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAABdUExURQAAAP////////////////////////////////// /////+Lm78zU48XO3/j4+6i1z4udwK+70/j5+6i10OLn76+81LC806i20KGvzMXN35KjxMzT47bC 17fC2AAAAG9JtkQAAAAKdFJOUwBAj9/PnyAQkD+yeUh8AAAAAWJLR0QAiAUdSAAAAAlwSFlzAAAL EwAACxMBAJqcGAAAAAd0SU1FB+cMBAM5IlSlicsAAAC1SURBVCjPlZJbEoMgDABjBLUBCmpb+7z/ NYsPNHVCO90fCDuBZAhApMCSPlC6gpm6IQGsJ6dIRI22oQwIUFGWAnReIvAXjXWGhSVs+6MPkbbb Tphsw0QvSRMWjCBdklaQNkn37dqTVFA/u7NYbXcZ3SC3QnSNjservHnv7yHc4/LYy7VWXm+Snsvh H/nk8pXkMlqddSt26UYB5j9bQ5GXcTyzqfhrNKEWc+ehjlR6l13iYTx/A7sEIFVH5s83AAAAJXRF WHRkYXRlOmNyZWF0ZQAyMDIzLTEyLTA0VDAyOjMyOjEzKzAwOjAw8A+j9gAAACV0RVh0ZGF0ZTpt b2RpZnkAMjAyMy0xMi0wNFQwMjozMjoxMyswMDowMIFSG0oAAAAodEVYdGRhdGU6dGltZXN0YW1w ADIwMjMtMTItMDRUMDM6NTc6MzQrMDA6MDCCz9vkAAAAAElFTkSuQmCC"}})])
          )
        }
      }
    